/* eslint-disable @typescript-eslint/naming-convention */
import _ from "lodash-es"

import { pageSizeSignal } from '../state/signals/userSettingsSignals.js'

import { SortDirectionType } from './constants'
import { isPreactSignal, stringifyRecursive } from './utils'

export const computeDisplayData = (currentPageSignal, sortedDataComputed) => {
	return () => {
		// Calculate the starting and ending indexes for pagination
		const startIndex = (currentPageSignal.value - 1) * pageSizeSignal.value
		const endIndex = startIndex + pageSizeSignal.value
		const display = sortedDataComputed.value.slice(startIndex, endIndex)
		return display
	}
}

export const computeSortedData = function (filteredDataSignal, sortColumnSignal, sortDirectionSignal = null) {
    return function () {
        // this function supports signals or strings for sort column name
        let sortColumn
        if (isPreactSignal(sortColumnSignal)) {
            sortColumn = sortColumnSignal.value
        }
        else if (typeof sortColumnSignal == 'string') {
            sortColumn = sortColumnSignal
        }
        else {
            sortColumn = ''
        }
        if (!Array.isArray(filteredDataSignal.value)) {
            console.error("Filtered data signal value is not an array")
            console.log(stringifyRecursive(filteredDataSignal.value))
            return []
        }
        // just return filtered data if no sorting
        if (!sortColumn || !sortColumn.length) {
            return [...filteredDataSignal.value]
        }
        // supports signals and strings for sort direction
        let direction
        if (isPreactSignal(sortDirectionSignal)) {
            direction = sortDirectionSignal.value
        }
        else if (typeof sortDirectionSignal == 'string') {
            direction = sortDirectionSignal
        }
        else {
            direction = SortDirectionType.ASCENDING
        }
        let _sortedData = [...filteredDataSignal.value]
        return _sortedData.sort((a, b) => {
            let _a = _.get(a, sortColumn, null)
            let _b = _.get(b, sortColumn, null)
            // Convert nulls to empty strings for sorting purposes
            _a = _a ? _a : ''
            _b = _b ? _b : ''
            // convert values to lowercase
            if (_a && _a.length) {
                _a = _a.toLowerCase()
            }
            if (_b && _b.length) {
                _b = _b.toLowerCase()
            }
            //console.log("(_a, _b) = (".concat(_a).concat(", ").concat(_b).concat(")"))
            if (direction == SortDirectionType.ASCENDING) {
                if (_a < _b) {
                    //console.log("b comes first ascending")
                    return -1
                }
                if (_a > _b) {
                    //console.log("a comes first ascending")
                    return 1
                }
                return 0
            }
            else {
                if (_a > _b) {
                    // console.log("b comes first descending")
                    return -1
                }
                if (_a < _b) {
                    //console.log("a comes first descending")
                    return 1
                }
                return 0
            }
        })
    }
}

export const computeStartDisplayRowNumber = (currentPageSignal) => {
	return () => {
		return ((currentPageSignal.value - 1) * pageSizeSignal.value) + 1
	}
}

export const computeEndDisplayRowNumber = (currentPageSignal, filteredDataComputed) => {
	return () => {
		const startIndex = (currentPageSignal.value - 1) * pageSizeSignal.value
		const endIndex = startIndex + pageSizeSignal.value
		return endIndex < filteredDataComputed.value.length ? endIndex : filteredDataComputed.value.length
	}
}

export const computeTotalPages = (filteredDataComputed) => {
    return () => {
		return Math.ceil(filteredDataComputed.value.length / parseInt(pageSizeSignal.value, 10))
	}
}